import { Component, OnInit } from '@angular/core';
import { AppService } from '@services/app.service';
import { CartStateService } from '@services/cartStateService';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrl: './my-orders.component.scss'
})
export class MyOrdersComponent implements OnInit {

  orders: any[] = [];
  loading = true;
  cartCount: number = 0;

  constructor(private appService: AppService,private cartState: CartStateService,) {}

  ngOnInit(): void {
    this.getMyOrders();
    this.cartState.cartCount$.subscribe(count => {
      this.cartCount = count;
    });
  }

  getMyOrders() {
    this.appService.getMyOrdersDetails().subscribe({
      next: (res: any) => {
        this.orders = res || [];
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  // Format date
  formatDate(timestamp: number): string {
    return new Date(timestamp).toLocaleDateString('en-IN');
  }
}